import React from 'react';
import PaymentsCharges from '../../PaymentsCharges';
import { CHARGE_HAS_COUPON_REDEEMED_STATUSES } from '@/dashboard/services/status/hasCouponRedeemedStatuses';
import { COUPON_FILTER_OPTIONS } from '@/dashboard/lib/chargesConstants';

const DiscountsCouponsPaymentsRedemptions = ({ coupon }) => {
  return (
    <PaymentsCharges
      title="One-time redemptions"
      baseFilters={{
        'coupon._id': coupon._id,
        status: CHARGE_HAS_COUPON_REDEEMED_STATUSES,
      }}
      hasCustomStatusFilter
      exportLabel="coupon redemptions"
      hidePageFilter
      filterOptions={COUPON_FILTER_OPTIONS}
    />
  );
};

export default DiscountsCouponsPaymentsRedemptions;
